var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7084 14.9007C17.7084 14.5406 17.7084 14.3606 17.7625 14.2002C17.92 13.7339 18.3352 13.5531 18.7512 13.3636C19.2188 13.1506 19.4525 13.0441 19.6842 13.0254C19.9472 13.0041 20.2107 13.0608 20.4355 13.1869C20.7335 13.3541 20.9413 13.6719 21.1541 13.9304C22.1368 15.1239 22.6281 15.7208 22.8079 16.3789C22.953 16.9099 22.953 17.4654 22.8079 17.9964C22.5457 18.9563 21.7172 19.761 21.104 20.5058C20.7904 20.8867 20.6335 21.0772 20.4355 21.1884C20.2107 21.3145 19.9472 21.3712 19.6842 21.3499C19.4525 21.3312 19.2188 21.2247 18.7512 21.0117C18.3352 20.8222 17.92 20.6414 17.7625 20.1752C17.7084 20.0147 17.7084 19.8347 17.7084 19.4746V14.9007Z",
    stroke: "white",
    strokeWidth: 1.5625
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.29171 14.9008C7.29171 14.4474 7.27898 14.0399 6.91245 13.7212C6.77913 13.6052 6.60238 13.5247 6.24891 13.3637C5.7813 13.1508 5.5475 13.0443 5.31583 13.0255C4.62078 12.9693 4.24683 13.4437 3.84601 13.9305C2.86332 15.1241 2.37198 15.7209 2.19219 16.379C2.0471 16.9101 2.0471 17.4655 2.19219 17.9966C2.45442 18.9565 3.28287 19.7611 3.89609 20.506C4.28263 20.9754 4.65188 21.4038 5.31583 21.3501C5.5475 21.3314 5.7813 21.2248 6.24891 21.0119C6.60238 20.8509 6.77913 20.7703 6.91245 20.6544C7.27898 20.3357 7.29171 19.9283 7.29171 19.4748V14.9008Z",
    stroke: "white",
    strokeWidth: 1.5625
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7917 13.021V10.9377C19.7917 6.91059 16.5271 3.646 12.5 3.646C8.47297 3.646 5.20837 6.91059 5.20837 10.9377V13.021",
    stroke: "white",
    strokeWidth: 1.5625,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIconWhite);
export default __webpack_public_path__ + "static/media/SupportIconWhite.3984b496234ed7c74549826e8067ec41.svg";
export { ForwardRef as ReactComponent };